<template>
  <div>
    <div class="wrap my-coaching-wrap">
      <div class="top-header">
        <h3>my 코칭</h3>
      </div>
      <div class="body-wrap">
        <div class="my-coaching-menu">
          <incMenu></incMenu>
        </div>
        <div class="today-coaching">
          <div class="clear">
            <h4 class="float-left">오늘 일정</h4>
            <p class="float-left">{{ total }}</p>
          </div>

          <ul>
            <li
              class="clear"
              :class="{ active: item.coarchingNoteSessionIdx == 0 }"
              @click="coachingView(item.sessionIdx)"
              v-for="(item, index) in list"
              :key="index"
            >
              <div class="w-50per float-left">
                <span>{{ item.sessionType }}</span>
                <h1>{{ item.userName }}</h1>
              </div>
              <div class="w-50per float-left">
                <p>
                  {{ item.start_time }}~{{ item.end_time }}&nbsp;&nbsp;|&nbsp;&nbsp;{{ item.currentSession }}/{{
                    item.totalSession
                  }}
                </p>
              </div>
            </li>
            <!-- <li class="clear" @click="coachingView()">
                            <div class="w-50per float-left">
                                <span>대면</span>
                                <h1>김소연</h1>
                            </div>
                            <div class="w-50per float-left">
                                <p>09:00~10:00&nbsp;&nbsp;|&nbsp;&nbsp;2/10</p>
                            </div>
                        </li>
                        <li class="clear disable" @click="coachingView()">
                            <div class="w-50per float-left">
                                <span>전화</span>
                                <h1>김소연</h1>
                            </div>
                            <div class="w-50per float-left">
                                <p>09:00~10:00&nbsp;&nbsp;|&nbsp;&nbsp;2/10</p>
                            </div>
                        </li> -->
          </ul>
        </div>
      </div>
      <incTab></incTab>
    </div>
  </div>
</template>
<script>
import incMenu from "@/components/inc/inc_menu.vue";
import incTab from "@/components/inc/inc_tab.vue";
import dayjs from "dayjs";
export default {
  name: "my_coaching",
  data: () => ({
    list: [],
    total: 0,
    coarIdx: 0,
    today: "",
  }),
  components: {
    incMenu,
    incTab,
  },
  mounted() {
    this.coarIdx = localStorage.getItem("idxTbCoarch");
    this.today = dayjs().format("YYYY-MM-DD");
    this.getReservedList();
  },
  methods: {
    getReservedList() {
      this.axios
        .get(`/front/coarch/${this.coarIdx}/schedule/today/${this.today}`)
        .then((res) => {
          if (res.data.success) {
            this.total = res.data.contentinfo.countTodaySchedule;
            this.list = res.data.contentinfo.todayScheduleList;
            for (let item of this.list) {
              item.start_time = dayjs(item.startDatetime).format("HH:mm");
              item.end_time = dayjs(item.endDatetime).format("HH:mm");
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    coachingView(sessionIdx) {
      this.$router.push({ name: "reservation_coaching_view", params: { sessionIdx: Number(sessionIdx) } });
    },
  },
};
</script>
